'use client'

import { Fit, Layout, useRive } from '@rive-app/react-webgl2'
import { useEffect } from 'react'

interface BusinessProfileSwitchLoaderProps {
  isVisible: boolean
}

export function BusinessProfileSwitchLoader({ isVisible }: BusinessProfileSwitchLoaderProps) {
  const { RiveComponent, rive } = useRive({
    src: '/animation/workflow_loading.riv',
    stateMachines: 'State Machine 1',
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
    }),
  })

  useEffect(() => {
    if (rive && isVisible) {
      rive.play()
    }
  }, [rive, isVisible])

  useEffect(() => {
    return () => {
      if (rive) {
        rive.cleanup()
      }
    }
  }, [rive])

  if (!isVisible) {
    return null
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <div className="h-32 w-32">
          <RiveComponent />
        </div>
        <div className="text-lg font-medium text-gray-700">Switching Business Profile...</div>
      </div>
    </div>
  )
}
